import { Toaster as Sonner } from "sonner"
import { CircleCheck, CircleX, Info, TriangleAlert, LoaderCircle } from "lucide-react"
import { useDarkMode } from "@/shared/hooks/useDarkMode"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { darkMode } = useDarkMode()

  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      duration={5000}
      theme={darkMode ? "dark" : "light"}
      icons={{
        success: <CircleCheck className="h-5 w-5" />,
        error: <CircleX className="h-5 w-5" />,
        info: <Info className="h-5 w-5" />,
        warning: <TriangleAlert className="h-5 w-5" />,
        loading: <LoaderCircle className="h-5 w-5 animate-spin" />,
      }}
      toastOptions={{
        style: { zoom: 1.1 },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:text-sm group-[.toaster]:py-4 group-[.toaster]:px-4",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-xs",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error:
            "group-[.toaster]:!border-l-4 group-[.toaster]:!border-l-destructive group-[.toaster]:!bg-red-50 dark:group-[.toaster]:!bg-red-950 group-[.toaster]:!shadow-[0_4px_12px_hsl(0_70%_50%/0.12)]",
          success:
            "group-[.toaster]:!border-l-4 group-[.toaster]:!border-l-success group-[.toaster]:!bg-emerald-50 dark:group-[.toaster]:!bg-emerald-950",
          warning:
            "group-[.toaster]:!border-l-4 group-[.toaster]:!border-l-warning group-[.toaster]:!bg-amber-50 dark:group-[.toaster]:!bg-amber-950",
          info:
            "group-[.toaster]:!bg-sky-50 dark:group-[.toaster]:!bg-sky-950",
          loading:
            "group-[.toaster]:!bg-sky-50 dark:group-[.toaster]:!bg-sky-950",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
